// extracted by mini-css-extract-plugin
export var dots = "Dots-module--dots--51868";
export var dots4 = "Dots-module--dots4--94ad1";